import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { CupService } from '../../shared/services/cup.service';
import { range } from 'rxjs';

@Component({
    selector: 'star-rating',
    templateUrl: './starrating.component.html',
    styleUrls: ['./starrating.component.css'],
    standalone: false
})
export class StarRatingComponent implements OnInit, OnDestroy {
    @Input() max: number = 5;
    @Input() value: number = 0;
    private checkedSubscription : any
    private unCheckedSubscription : any
    
    public checkedCount: number[] = [];
    public unCheckedCount: number[] = [];

    constructor(private cupService : CupService) { }

    ngOnInit() {
        this.checkedSubscription = range(1, (this.value)).subscribe(num => 
            this.checkedCount.push(num)
            );
        this.unCheckedSubscription = range(1, (this.max - this.value)).subscribe(num => this.unCheckedCount.push(num));
    }

    ngOnDestroy(): void {
        if(this.checkedSubscription){
            this.checkedSubscription.unsubscribe();
        }
        if(this.unCheckedSubscription){
            this.unCheckedSubscription.unsubscribe();
        }
    }

}
